module.exports = __webpack_public_path__ + "static/media/16-15.d310b9ab.mp3";